module.exports = __webpack_public_path__ + "static/media/time_log_off@2x.6ae0bc8a.svg";